"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _proptypes = require("../utils/proptypes");

var _styles = require("../styles");

var _Links = _interopRequireDefault(require("./Links"));

var _Jumper = _interopRequireDefault(require("./Jumper"));

var _Simple = _interopRequireDefault(require("./Simple"));

var _PageSizeList = _interopRequireDefault(require("./PageSizeList"));

var _config = require("../config");

var _getDataset = _interopRequireDefault(require("../utils/dom/getDataset"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Pagination =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Pagination, _PureComponent);

  function Pagination() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Pagination.prototype;

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        align = _this$props.align,
        layout = _this$props.layout,
        size = _this$props.size,
        style = _this$props.style;
    var rtl = (0, _config.isRTL)();
    var className = (0, _classnames.default)((0, _styles.paginationClass)('_', size, align, rtl && 'rtl'), this.props.className);
    var sectionClassName = (0, _styles.paginationClass)('section');
    return _react.default.createElement("div", _extends({
      className: className,
      style: style
    }, (0, _getDataset.default)(this.props)), layout.map(function (section, i) {
      switch (section) {
        case 'links':
          return _react.default.createElement(_Links.default, _extends({
            key: section
          }, _this.props));

        case 'list':
          return _react.default.createElement(_PageSizeList.default, _extends({
            key: section
          }, _this.props));

        case 'jumper':
          return _react.default.createElement(_Jumper.default, _extends({
            key: section
          }, _this.props));

        case 'simple':
          return _react.default.createElement(_Simple.default, _extends({
            key: section
          }, _this.props));

        default:
          if (typeof section === 'function') {
            return _react.default.createElement("div", {
              key: i,
              className: sectionClassName
            }, _react.default.createElement("span", null, section(_this.props)));
          }

          return null;
      }
    }));
  };

  return Pagination;
}(_react.PureComponent);

Pagination.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'size', 'type'), {
  align: _propTypes.default.string,
  current: _propTypes.default.number.isRequired,
  layout: _propTypes.default.array,
  onChange: _propTypes.default.func.isRequired,
  pageSize: _propTypes.default.number.isRequired,
  span: _propTypes.default.number,
  text: _propTypes.default.object,
  total: _propTypes.default.number.isRequired
});
Pagination.defaultProps = _objectSpread({}, _proptypes.defaultProps, {
  layout: ['links'],
  span: 5,
  text: {}
});
var _default = Pagination;
exports.default = _default;